import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import DateCell from '../components/cells/DateCell';
import { formatMoney } from '../helpers/money';
import { openUrlAndDownload } from '../helpers';

export const getClientDocumentSummariesColumns = () => [
  { field: 'operationId',
    headerName: 'N° de operación',
    disableColumnMenu: true,
    headerClassName: 'first-column-header',
    cellClassName: 'first-column-cell',
    flex: 1,
    renderCell: ({ row }) => <Typography variant="body1">{row.operationId}</Typography>,
  },
  { field: 'operationDate',
    headerName: 'Fecha de operación',
    disableColumnMenu: true,
    headerClassName: 'second-column-header',
    cellClassName: 'second-column-cell',
    flex: 1,
    renderCell: ({ row }) => <DateCell date={row.operationDate} />,
  },
  { field: 'invoicesCount',
    headerName: 'N° de facturas',
    disableColumnMenu: true,
    headerClassName: 'third-column-header',
    cellClassName: 'third-column-cell',
    flex: 1,
    renderCell: ({ row }) => <Typography variant="body1">{row.invoicesCount} factura{row.invoicesCount > 1 ? 's' : ''}</Typography>,
  },
  {
    field: 'totalAmountTransferred',
    headerName: 'Giro por la operación',
    disableColumnMenu: true,
    headerClassName: 'fourth-column-header',
    cellClassName: 'fourth-column-cell',
    flex: 1,
    renderCell: ({ row }) => <Typography variant="body1">{formatMoney(row.totalAmountTransferred, true)}</Typography>,
  },
  {
    field: 'pdfFile',
    headerName: 'Documento',
    disableColumnMenu: true,
    headerClassName: 'fifth-column-header',
    cellClassName: 'fifth-column-cell',
    flex: 1,
    renderCell: ({ row }) => (
      <Button
        variant="link"
        color="primary"
        onClick={() => openUrlAndDownload(row.pdfFile, `liquidacion_${row.operationId}.pdf`)}
        sx={{ padding: 0 }}
      >
        Descargar
        <DownloadIcon />
      </Button>
    ),
  },
];

export const CLIENT_SUMMARY_OPTIONS = {
  PORTFOLIO: 'portfolio',
  SETTLEMENTS: 'settlements',
};
